import { createApi } from '@reduxjs/toolkit/query/react';

import {
  getBaseUrlObNextGen,
  getObNextGenApiUrlLists,
} from '../../../constants/obNextGenConstants';
import { axiosBaseQuery } from '../../../services/baseQuery';

import { discoveryConfigByIdApi } from './getDiscoveryConfigByIdSlice';

export interface SaveDiscoveryConfigArgs {
  id: number;
  tabs: {
    sortOrder: number;
    name: string;
    details: Record<string, unknown>;
  }[];
}

// define the actual response shape
export interface SaveDiscoveryConfigResponse {
  status: number;
  message: string;
}

const { SAVE_DISCOVERY_CONFIG } = getObNextGenApiUrlLists();

export const saveDiscoveryConfigApi = createApi({
  reducerPath: 'saveDiscoveryConfigApi',
  baseQuery: axiosBaseQuery({
    baseUrl: getBaseUrlObNextGen(),
  }),
  tagTypes: ['DiscoveryConfig'],
  endpoints: (builder) => ({
    saveDiscoveryConfig: builder.mutation<
      SaveDiscoveryConfigResponse, // <- return type now matches your API
      SaveDiscoveryConfigArgs
    >({
      query: ({ id, tabs }) => ({
        url: `${SAVE_DISCOVERY_CONFIG}/${id}`,
        method: 'PUT',
        data: { tabs },
      }),
      // pull the raw response through
      transformResponse: (response: SaveDiscoveryConfigResponse) => response,
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          // after saving, invalidate so the parent refetches
          dispatch(
            discoveryConfigByIdApi.util.invalidateTags([
              { type: 'DiscoveryConfig' as const, id: arg.id },
            ])
          );
        } catch {
          // ignore
        }
      },
    }),
  }),
});

export const { useSaveDiscoveryConfigMutation } = saveDiscoveryConfigApi;
